var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVideo(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "video_prefix__a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    rx: 0
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#video_prefix__a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.522 2.747a.2.2 0 01-.098-.098l-.576-1.25a.2.2 0 00-.363 0l-.577 1.25a.2.2 0 01-.098.098l-1.25.576a.2.2 0 000 .363l1.25.576a.2.2 0 01.098.098l.577 1.25a.2.2 0 00.363 0l.576-1.25a.2.2 0 01.098-.098l1.25-.576a.2.2 0 000-.363l-1.25-.576zm2.29 9.425V5.953a.75.75 0 00-1.5 0v6.219q0 .25-.25.25H1.938q-.25 0-.25-.25V3.828q0-.103.073-.177.073-.073.177-.073h6.937a.75.75 0 000-1.5H1.937q-.724 0-1.237.513-.512.512-.512 1.237v8.344q0 .725.512 1.237.513.513 1.237.513h12.126q.724 0 1.237-.513.512-.512.512-1.237zm-9.631-6.19a.4.4 0 01.616-.337l3.125 2.004a.4.4 0 01.002.672L6.799 10.35a.4.4 0 01-.618-.335V5.982z",
    fillRule: "evenodd",
    fill: "#FFF"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVideo);
export default __webpack_public_path__ + "static/media/video.46e1ba69.svg";
export { ForwardRef as ReactComponent };